import { isUndNullEmp } from '../../helpers/main.js';

export class PasswordChange {
    constructor(
        _userId = '',
        _password = '',
        _newPassword = '',
        _newPasswordConfirm = '',
    ) {
        this.userId = _userId;
        this.password = _password;
        this.newPassword = _newPassword;
        this.newPasswordConfirm = _newPasswordConfirm
    }

    static getClassName = () => {
        return 'PasswordChange - class';
    }

    static minMaxLength = (upperCase = false) => {
        if (upperCase) {
            return {
                min: {
                    UserId: 10,
                    Password: 6,
                    NewPassword: 6,
                    NewPasswordConfirm: 6,
                },
                max: {
                    UserId: 450,
                    Password: 12,
                    NewPassword: 12,
                    NewPasswordConfirm: 12,
                },
            };
        } else {
            return {
                min: {
                    userId: 10,
                    password: 6,
                    newPassword: 6,
                    newPasswordConfirm: 6,
                },
                max: {
                    userId: 450,
                    password: 12,
                    newPassword: 12,
                    newPasswordConfirm: 12,
                },
            };
        }
    }

    static class = (obj = {}, upperCase = false) => {
        if (!isUndNullEmp({ data: obj, subMethod: this.getClassName() })?.result) {
            if (upperCase) {
                return new PasswordChange(
                    obj.UserId,
                    obj.Password,
                    obj.NewPassword,
                    obj.NewPasswordConfirm,
                );
            } else {
                return new PasswordChange(
                    obj.userId,
                    obj.password,
                    obj.newPassword,
                    obj.newPasswordConfirm,
                );
            }
        } else {
            return new PasswordChange();
        }
    }
}

//#region old code
// export class PasswordRecoveryUserNoId {
//     constructor(
//         _password = '',
//         _newPassword = '',
//         _newPasswordConfirm = false,
//     ) {
//         this.password = _password;
//         this.newPassword = _newPassword;
//         this.newPasswordConfirm = _newPasswordConfirm
//     }

//     static getClassName = () => {
//         return 'PasswordRecoveryUserNoId - class';
//     }

//     static class = (obj = {}, upperCase = false) => {
//         if (!isUndNullEmp({ data: obj, subMethod: this.getClassName() })?.result) {
//             if (upperCase) {
//                 return new PasswordRecoveryUserNoId(
//                     obj.Password,
//                     obj.NewPassword,
//                     obj.NewPasswordConfirm,
//                 );
//             } else {
//                 return new PasswordRecoveryUserNoId(
//                     obj.password,
//                     obj.newPassword,
//                     obj.newPasswordConfirm,
//                 );
//             }
//         } else {
//             return new PasswordRecoveryUserNoId();
//         }
//     }
// }
//#endregion old code